var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container calendar-list-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _vm.areas.length > 0
            ? _c(
                "el-select",
                {
                  staticClass: "filter-item",
                  attrs: {
                    "default-first-option": "",
                    placeholder: "请选择区域",
                    clearable: "",
                  },
                  model: {
                    value: _vm.listQuery.area_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.listQuery, "area_id", $$v)
                    },
                    expression: "listQuery.area_id",
                  },
                },
                _vm._l(_vm.areas, function (item) {
                  return _c("el-option", {
                    key: item.role_id,
                    attrs: { label: item.name, value: item.role_id },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              attrs: { filterable: "", placeholder: "酒店", clearable: "" },
              model: {
                value: _vm.listQuery.hotel_id,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "hotel_id", $$v)
                },
                expression: "listQuery.hotel_id",
              },
            },
            _vm._l(_vm.hotelList, function (item) {
              return _c("el-option", {
                key: item.hotel_id,
                attrs: { label: item.name, value: item.hotel_id },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v("\n      搜索\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              staticStyle: { "margin-left": "10px" },
              attrs: { type: "primary", icon: "el-icon-edit" },
              on: { click: _vm.addBtn },
            },
            [_vm._v("\n      添加\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          key: "tableList",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "给我一点时间",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "ID", width: "65" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.id))])]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "所属酒店",
              "class-name": "overflow-on",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.hotelInfo.name) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "房型名称",
              "class-name": "overflow-on",
              width: "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.roomInfo.name) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", width: "80", label: "城市" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.hotelInfo.city))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "尾甩日期" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.isSet
                      ? _c(
                          "span",
                          [
                            _c("el-date-picker", {
                              attrs: {
                                clearable: false,
                                "value-format": "yyyyMMdd",
                              },
                              model: {
                                value: scope.row.start_date,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "start_date", $$v)
                                },
                                expression: "scope.row.start_date",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-date-picker", {
                              attrs: {
                                clearable: false,
                                "value-format": "yyyyMMdd",
                              },
                              model: {
                                value: scope.row.end_date,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "end_date", $$v)
                                },
                                expression: "scope.row.end_date",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("span", [
                          _vm._v(
                            _vm._s(scope.row.start_date) +
                              " ~ " +
                              _vm._s(scope.row.end_date)
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "尾甩时段" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.isSet
                      ? _c(
                          "span",
                          [
                            _c("el-time-select", {
                              attrs: {
                                clearable: false,
                                "value-format": "HH:mm:ss",
                                "picker-options": {
                                  start: "00:00",
                                  step: "00:15",
                                  end: "23:30",
                                },
                              },
                              model: {
                                value: scope.row.start_time,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "start_time", $$v)
                                },
                                expression: "scope.row.start_time",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-time-select", {
                              attrs: {
                                clearable: false,
                                "value-format": "HH:mm:ss",
                                "picker-options": {
                                  start: "00:15",
                                  step: "00:15",
                                  end: "24:00",
                                },
                              },
                              model: {
                                value: scope.row.end_time,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "end_time", $$v)
                                },
                                expression: "scope.row.end_time",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("span", [
                          _vm._v(
                            _vm._s(scope.row.start_time) +
                              " 至 " +
                              _vm._s(scope.row.end_time)
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "结算价", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.isSet
                      ? _c(
                          "span",
                          [
                            _c("el-input", {
                              attrs: { size: "mini" },
                              model: {
                                value: scope.row.price,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "price", $$v)
                                },
                                expression: "scope.row.price",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("span", [_vm._v(_vm._s(scope.row.price))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "扣减金额", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.isSet
                      ? _c(
                          "span",
                          [
                            _c("el-input", {
                              attrs: { size: "mini" },
                              model: {
                                value: scope.row.discount,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "discount", $$v)
                                },
                                expression: "scope.row.discount",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("span", [_vm._v(_vm._s(scope.row.discount))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "库存", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.isSet
                      ? _c(
                          "span",
                          [
                            _c("el-input", {
                              attrs: { size: "mini" },
                              model: {
                                value: scope.row.stock,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "stock", $$v)
                                },
                                expression: "scope.row.stock",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("span", [_vm._v(_vm._s(scope.row.stock))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    !scope.row.isSet && scope.row.status == 1
                      ? _c(
                          "span",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editBtn(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            编辑\n          ")]
                            ),
                          ],
                          1
                        )
                      : _c(
                          "span",
                          [
                            scope.row.status == 1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.doEdit(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("\n            保存\n          ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    scope.row.status == 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.downShelf(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          下架\n        ")]
                        )
                      : _c("span", [_vm._v("已下架")]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container text-right" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              total: _vm.pagination.total,
              "current-page": _vm.listQuery.page,
              "page-sizes": [20],
              "page-size": _vm.listQuery.limit,
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: _vm.dialogTitle, visible: _vm.dialogFormVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "temp",
              staticClass: "small-space",
              staticStyle: { width: "800px", "margin-left": "20px" },
              attrs: {
                model: _vm.temp,
                "label-position": "right",
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "选择酒店", prop: "hotel_id", required: "" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { filterable: "", placeholder: "酒店" },
                      on: { change: _vm.changeHotel },
                      model: {
                        value: _vm.temp.hotel_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.temp, "hotel_id", $$v)
                        },
                        expression: "temp.hotel_id",
                      },
                    },
                    _vm._l(_vm.hotelList, function (item) {
                      return _c("el-option", {
                        key: item.hotel_id,
                        attrs: { label: item.name, value: item.hotel_id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.temp.detail, function (domain, index) {
                return _c(
                  "div",
                  {
                    key: domain.key,
                    staticClass: "room-box",
                    attrs: { label: "房型选择" + index, prop: "detail[]" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "选择房型", required: "" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  filterable: "",
                                  placeholder: "房型",
                                  "data-index": "index",
                                },
                                on: { change: _vm.changeRoom },
                                model: {
                                  value: domain.room_id,
                                  callback: function ($$v) {
                                    _vm.$set(domain, "room_id", $$v)
                                  },
                                  expression: "domain.room_id",
                                },
                              },
                              _vm._l(_vm.roomList, function (item) {
                                return _c("el-option", {
                                  key: item.room_id,
                                  attrs: {
                                    label: item.name,
                                    value: item.room_id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "price", label: "结算价" } },
                              [
                                _c("el-input", {
                                  model: {
                                    value: domain.price,
                                    callback: function ($$v) {
                                      _vm.$set(domain, "price", $$v)
                                    },
                                    expression: "domain.price",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "尾甩日期", required: "" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "start_date" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: { "value-format": "yyyyMMdd" },
                                  model: {
                                    value: domain.start_date,
                                    callback: function ($$v) {
                                      _vm.$set(domain, "start_date", $$v)
                                    },
                                    expression: "domain.start_date",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticClass: "line text-center",
                            attrs: { span: 2 },
                          },
                          [_vm._v("\n            -\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "end_time" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: { "value-format": "yyyyMMdd" },
                                  model: {
                                    value: domain.end_date,
                                    callback: function ($$v) {
                                      _vm.$set(domain, "end_date", $$v)
                                    },
                                    expression: "domain.end_date",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "扣减金额", prop: "price" } },
                              [
                                _c("el-input", {
                                  model: {
                                    value: domain.discount,
                                    callback: function ($$v) {
                                      _vm.$set(domain, "discount", $$v)
                                    },
                                    expression: "domain.discount",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "尾甩时段", required: "" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "start_time" } },
                              [
                                _c("el-time-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "value-format": "HH:mm:ss",
                                    "picker-options": {
                                      start: "00:00",
                                      step: "00:15",
                                      end: "23:30",
                                    },
                                  },
                                  model: {
                                    value: domain.start_time,
                                    callback: function ($$v) {
                                      _vm.$set(domain, "start_time", $$v)
                                    },
                                    expression: "domain.start_time",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticClass: "line text-center",
                            attrs: { span: 2 },
                          },
                          [_vm._v("\n            -\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "end_time" } },
                              [
                                _c("el-time-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "value-format": "HH:mm:ss",
                                    "picker-options": {
                                      start: "00:00",
                                      step: "00:15",
                                      end: "24:00",
                                    },
                                  },
                                  model: {
                                    value: domain.end_time,
                                    callback: function ($$v) {
                                      _vm.$set(domain, "end_time", $$v)
                                    },
                                    expression: "domain.end_time",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "stock", label: "库存" } },
                              [
                                _c("el-input", {
                                  model: {
                                    value: domain.stock,
                                    callback: function ($$v) {
                                      _vm.$set(domain, "stock", $$v)
                                    },
                                    expression: "domain.stock",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { "margin-left": "100px" } },
                      [
                        _c("el-button", { on: { click: _vm.addDomain } }, [
                          _vm._v("\n            添加房型\n          "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.removeDomain(domain)
                              },
                            },
                          },
                          [_vm._v("\n            删除\n          ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("\n        取 消\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.btn },
                  on: {
                    click: function ($event) {
                      return _vm.addSpecial()
                    },
                  },
                },
                [_vm._v("\n        确 定\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }